import {
  CREATE_BRANDED_FIXTURE,
  CREATE_BRANDED_FIXTURE_SUCCESS,
  CREATE_BRANDED_FIXTURE_FAILED,
  FETCH_BRANDED_FIXTURES_SUCCESS,
  FETCH_BRANDED_FIXTURES,
  FETCH_BRANDED_FIXTURES_FAILED,
  SEARCH_BRANDED_FIXTURES,
  SEARCH_BRANDED_FIXTURES_SUCCESS,
  SEARCH_BRANDED_FIXTURES_FAILED,
  SET_SEARCH_BRANDED_FIXTURES,
  SET_BRANDED_FIXTURES_SORT_CRITERIAS,
  FETCH_COLLECTIONS,
  FETCH_COLLECTIONS_SUCCESS,
  FETCH_COLLECTIONS_FAILED,
  FETCH_VENDOR_COLLECTION_LISTINGS,
  FETCH_VENDOR_COLLECTION_LISTINGS_SUCCESS,
  FETCH_VENDOR_COLLECTION_LISTINGS_FAILED,
  UPDATE_BRANDED_FIXTURE,
  UPDATE_BRANDED_FIXTURE_SUCCESS,
  UPDATE_BRANDED_FIXTURE_FAILED,
  FETCH_OFFICE_FIXTURES,
  FETCH_OFFICE_FIXTURES_SUCCESS,
  FETCH_OFFICE_FIXTURES_FAILED,
  FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES,
  FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_SUCCESS,
  FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_FAILED,
  CLEAR_DEFAULT_OFFICE_BRANDED_FIXTURES,
  SAVE_OFFICE_FIXTURES,
  SAVE_OFFICE_FIXTURES_SUCCESS,
  SAVE_OFFICE_FIXTURES_FAILED,
} from './branded-fixtures-actions';

export const BRANDED_FIXTURES_STATE_KEY = 'BRANDED_FIXTURES_REDUCER';

export interface VendorAndCollectionListingDto {
  acuityCollectionID: number;
  vendorName: string | null;
  collectionName: string | null;
  notes: string | null;
  databaseCollectionID: number | null;
  acuityVendorID: number | null;
  bit: boolean | null;
  collectionType: string | null;
}

type TState = {
  brandedFixture: {
    contents: any[];
    pages: number;
    total: number;
  };
  search: {
    page: number;
    size: number;
  };
  sorting: {
    field: string;
    order: 'asc' | 'desc';
  };
  loading: boolean;
  error: any;
  brandedFixtureDetails: any;
  detailsLoading: boolean;
  collections: any[];
  collectionsLoading: boolean;
  vendorCollectionListings: VendorAndCollectionListingDto[];
  vendorCollectionListingsLoading: boolean;
  officeFixtures: any[];
  officeFixturesLoading: boolean;
  defaultOfficeBrandedFixtures: any[];
  defaultOfficeBrandedFixturesLoading: boolean;
  officeFixturesSaving: boolean;
};

const initialState: TState = {
  brandedFixture: {
    contents: [],
    pages: 0,
    total: 0,
  },
  search: {
    page: 0,
    size: 15,
  },
  sorting: {
    field: 'vendorName',
    order: 'asc',
  },
  loading: false,
  error: null,
  brandedFixtureDetails: null,
  detailsLoading: false,
  collections: [],
  collectionsLoading: false,
  vendorCollectionListings: [],
  vendorCollectionListingsLoading: false,
  officeFixtures: [],
  officeFixturesLoading: false,
  defaultOfficeBrandedFixtures: [],
  defaultOfficeBrandedFixturesLoading: false,
  officeFixturesSaving: false,
};

export const brandedFixturesReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case FETCH_BRANDED_FIXTURES:
      return {
        ...state,
        loading: true,
      };
    case FETCH_BRANDED_FIXTURES_SUCCESS:
      return {
        ...state,
        loading: false,
        brandedFixtureDetails: payload,
      };
    case FETCH_BRANDED_FIXTURES_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case CREATE_BRANDED_FIXTURE:
    case UPDATE_BRANDED_FIXTURE:
      return {
        ...state,
        detailsLoading: true,
      };

    case CREATE_BRANDED_FIXTURE_SUCCESS:
    case UPDATE_BRANDED_FIXTURE_SUCCESS:
      return {
        ...state,
        detailsLoading: false,
      };

    case CREATE_BRANDED_FIXTURE_FAILED:
    case UPDATE_BRANDED_FIXTURE_FAILED:
      return {
        ...state,
        detailsLoading: false,
        error: payload,
      };

    case SET_SEARCH_BRANDED_FIXTURES:
      return {
        ...state,
        search: { ...state.search, ...payload },
      };

    case SET_BRANDED_FIXTURES_SORT_CRITERIAS:
      return {
        ...state,
        sorting: payload,
      };

    case SEARCH_BRANDED_FIXTURES:
      return {
        ...state,
        loading: true,
      };

    case SEARCH_BRANDED_FIXTURES_SUCCESS:
      return {
        ...state,
        loading: false,
        brandedFixture: payload,
      };

    case SEARCH_BRANDED_FIXTURES_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case FETCH_COLLECTIONS:
      return {
        ...state,
        collectionsLoading: true,
      };

    case FETCH_COLLECTIONS_SUCCESS:
      return {
        ...state,
        collectionsLoading: false,
        collections: payload,
      };

    case FETCH_COLLECTIONS_FAILED:
      return {
        ...state,
        collectionsLoading: false,
        error: payload,
      };

    case FETCH_VENDOR_COLLECTION_LISTINGS:
      return {
        ...state,
        vendorCollectionListingsLoading: true,
      };

    case FETCH_VENDOR_COLLECTION_LISTINGS_SUCCESS:
      return {
        ...state,
        vendorCollectionListingsLoading: false,
        vendorCollectionListings: payload,
      };

    case FETCH_VENDOR_COLLECTION_LISTINGS_FAILED:
      return {
        ...state,
        vendorCollectionListingsLoading: false,
        error: payload,
      };

    case FETCH_OFFICE_FIXTURES:
      return { ...state, officeFixturesLoading: true };
    case FETCH_OFFICE_FIXTURES_SUCCESS:
      return { ...state, officeFixturesLoading: false, officeFixtures: payload || [] };
    case FETCH_OFFICE_FIXTURES_FAILED:
      return { ...state, officeFixturesLoading: false, error: payload };
    case FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES:
      return { ...state, defaultOfficeBrandedFixturesLoading: true, defaultOfficeBrandedFixtures: [] };
    case FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_SUCCESS:
      return { ...state, defaultOfficeBrandedFixturesLoading: false, defaultOfficeBrandedFixtures: payload || [] };
    case FETCH_DEFAULT_OFFICE_BRANDED_FIXTURES_FAILED:
      return { ...state, defaultOfficeBrandedFixturesLoading: false, error: payload };
    case CLEAR_DEFAULT_OFFICE_BRANDED_FIXTURES:
      return { ...state, defaultOfficeBrandedFixtures: [], defaultOfficeBrandedFixturesLoading: false };
    case SAVE_OFFICE_FIXTURES:
      return { ...state, officeFixturesSaving: true };
    case SAVE_OFFICE_FIXTURES_SUCCESS:
      return { ...state, officeFixturesSaving: false, officeFixtures: payload || state.officeFixtures };
    case SAVE_OFFICE_FIXTURES_FAILED:
      return { ...state, officeFixturesSaving: false, error: payload };

    default:
      return state;
  }
};
